import { render, staticRenderFns } from "./sms.vue?vue&type=template&id=52e35cd9&"
import script from "./sms.vue?vue&type=script&lang=js&"
export * from "./sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e35cd9')) {
      api.createRecord('52e35cd9', component.options)
    } else {
      api.reload('52e35cd9', component.options)
    }
    module.hot.accept("./sms.vue?vue&type=template&id=52e35cd9&", function () {
      api.rerender('52e35cd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/sms.vue"
export default component.exports